<template>
    <div>
        <app-entrega
            :entrega="entrega"
            :entregasServicos="obterEntregasServicos()"
            @obterEntregaAtualizada="obterAtualizacao()"
        >
            <template slot="contratacaoFooter">
                <app-btn-voltar></app-btn-voltar>
            </template>
            <template slot="entregaFooter">
                <!-- <b-button variant="primary" @click.stop="confirmarAprovarReprovarEntrega('A')" v-if="mostrarBtnAprovarReprovar">
          <span><i class="fa fa-check-circle"></i> Aprovar</span>
        </b-button>
        <b-button variant="danger" @click.stop="confirmarAprovarReprovarEntrega('R')" v-if="mostrarBtnAprovarReprovar">
          <span><i class="fa fa-times-circle"></i> Reprovar</span>
                </b-button>-->
            </template>
        </app-entrega>
    </div>
</template>

<script>
import EntregasServicos from './EntregasServicos'
import Entrega from '@/app/credenciados/componentes/entregas/Entrega'

export default {
    data() {
        return {
            entrega: {}
        }
    },

    methods: {
        obterEntrega() {
            this.$store.dispatch('addRequest')
            EntregasServicos.obterPorIdPorCredenciado(
                this.$route.params.entregaId
            ).then(response => {
                if (response) {
                    if (response.success) {
                        this.entrega = response.data
                    } else {
                        this.$toast.error(
                            'Erro ao obter entrega!!!',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        obterEntregasServicos() {
            return EntregasServicos
        },

        obterAtualizacao() {
            this.obterEntrega()
            this.$emit('obterAtualizacao')
        }
    },

    created() {
        this.obterEntrega()
    },

    components: {
        AppEntrega: Entrega
    }
}
</script>
